import { STATUS } from 'consts/statuses';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';

export function useWaiver() {
	const ctx = useContext(AppContext);
	const { config, http } = ctx;
	const { token } = useParams();
	const [status, setStatus] = useState(token ? STATUS.UNKNOWN : STATUS.NO_ID);

	useEffect(() => {
		if (token) {
			http
				.post(`${config.API.waiver}/ApproveWaiver?waiverId=${token}`, { token })
				.then(() => setStatus(STATUS.SUCCESS))
				.catch(() => setStatus(STATUS.ERROR));
		}
	}, [token, config.API.waiver]); // eslint-disable-line react-hooks/exhaustive-deps

	return {
		...ctx,
		status
	};
}
